import { useContext } from 'react';
import { ActionBroadcasterContext } from './action-broadcaster-context';

export function useActionBroadcaster() {
    const value = useContext(ActionBroadcasterContext);
    if (!value) {
        throw new Error('Unexpectedly did not find action broadcaster context');
    }
    return value;
}
